<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :settings="false"
                    search
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import NetsisAccountantApi from '@/api/netsis-accountant';

export default{
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {name:"Cari Kodu",key:"CariKod",thClass:'w-15',sortable:true},
                {name:"Cari İsmi",key:"CariIsim",thClass:'w-40',sortable:true},
                {name:"Alacak (TL)",key:"Alacak",thClass:'w-15',sortable:false,component:true, componentOptions:{ name:'cari/CustomerCreditForList' },tdClass:"text-nowrap text-right"},
                {name:"Kalan Borç (TL)",key:"Borc",thClass:'w-15',sortable:false,component:true, componentOptions:{ name:'cari/CustomerDebtForList' },tdClass:"text-nowrap text-right"},
                {name:"Bakiye (TL)",key:"Bakiye",thClass:'w-15',sortable:false,component:true, componentOptions:{ name:'cari/CustomerBalanceForList' },tdClass:"text-nowrap text-right"},
            ],
            buttons:[
                { text:"Detay",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.detail },
            ]
        }
    },
    methods:{
        provider(data){
            return NetsisAccountantApi.Cari.Table(data)
        },
        detail(item){
            let route = this.$router.resolve({name:'cari-detail',params:{code:item.CariKod},query:{c:item.CariIsim}})
            window.open(route.href, "_blank")
        },
    }
}
</script>